/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-header.vue?vue&type=template&id=e60d6872&scoped=true&"
import script from "./category-header.vue?vue&type=script&lang=js&"
export * from "./category-header.vue?vue&type=script&lang=js&"
import style0 from "./category-header.vue?vue&type=style&index=0&id=e60d6872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60d6872",
  null
  
)

export default component.exports